import { StoreBase } from "imagica-corekit/dist/base/cutil/StoreBase";
import { isFunction } from "lodash";
import { PreviewAppValue } from "@uiview/views/PreviewApp/model/PreviewAppValue";
import { CreatorNodesStore } from "../store/CreatorNodesStore";
import { PreviewAppValueGenUtil } from "@uiview/views/PreviewApp/PreviewAppValueGenUtil";

export class CreatorSaasAppStoreState {
  /**
   * 该状态目前仅用于强制跟新 sassuidata 数据，当 sassuidata 和 node同步后则移除
   */
  forceUpdates = 0;
  saasUIData = new PreviewAppValue();

  copyWith(params: { saasUIData?: PreviewAppValue; forceUpdates?: number }): CreatorSaasAppStoreState {
    const newState = new CreatorSaasAppStoreState();
    newState.saasUIData = params.saasUIData ?? this.saasUIData;
    newState.forceUpdates = params.forceUpdates ?? this.forceUpdates;

    return newState;
  }
}

export type DispatchType<T> = T | ((prevState: T) => T);

// 原 useSaasAndThinkAppState 状态
export class CreatorSaasAppStore extends StoreBase<CreatorSaasAppStoreState> {
  lastSaasUIData: PreviewAppValue;

  constructor(public creatorNodesStore: CreatorNodesStore) {
    super(() => new CreatorSaasAppStoreState());
    this.lastSaasUIData = new PreviewAppValue();
  }

  setSaasUIData = (value: DispatchType<CreatorSaasAppStoreState["saasUIData"]>): void => {
    if (isFunction(value)) {
      const saasUIData = value(this.lastSaasUIData);
      saasUIData.outputV2 = PreviewAppValue.toPreviewOutputv2(saasUIData.output, this.creatorNodesStore.getNodes);

      this.lastSaasUIData = saasUIData;
      this.emit(this.state.copyWith({ saasUIData }));
      return;
    }

    // if (!value.length) {
    //   console.trace("empty");
    // }

    const saasUIData = value;
    saasUIData.outputV2 = PreviewAppValue.toPreviewOutputv2(value?.output, this.creatorNodesStore.getNodes);

    this.lastSaasUIData = saasUIData;

    this.emit(this.state.copyWith({ saasUIData }));
  };
  emptySaasUIData(): void {
    this.setSaasUIData(PreviewAppValueGenUtil.genPreviewAppValue());
  }

  forceUpdates(): void {
    this.emit(this.state.copyWith({ forceUpdates: Date.now() }));
  }
}
